// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import "@/common/base.css"
import * as api from "@/api"
import util from "@/common/util"
// Element 额外提供了一系列类名，用于在某些条件下隐藏元素。这些类名可以添加在任何 DOM 元素或自定义组件上。
import 'element-ui/lib/theme-chalk/display.css';
// import "@/common/common.scss"
import "@/common/newsdetail.css"

Vue.config.productionTip = false
Vue.use(Element, {
  size: 'small' // set element-ui default size
})

// 挂载请求
Vue.prototype.$req = api

// 全局的messge
Vue.prototype.$message = Element.Message

// 全局的util
Vue.prototype.$util = util
Vue.prototype.$clone = util.clone
Vue.prototype.$merge = util.merge

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js